import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { CoreGoogleDeviceImportConfiguration } from '../../../../../../models/CoreGoogleDeviceImportModels';
import CheckboxListItem from '../../../../../misc/CheckboxListItem';


interface GoogleDeviceImportConfigurationProps {
    disabled: boolean
    configuration: CoreGoogleDeviceImportConfiguration
    updatePart: (part: Partial<CoreGoogleDeviceImportConfiguration>) => void
    active: boolean
    onValidChange: (arg: boolean) => void 
};
    
const GoogleDeviceImportConfiguration = (props: GoogleDeviceImportConfigurationProps) => {
    const { t } = useTranslation(['configuration', 'common']);

    const [open, setOpen] = useState<boolean>(true);

    useEffect(() => {
        props.onValidChange(false);
    }, [props.onValidChange]);

    return (
        <Card className="edit_module">
            <CardHeader tag="h2">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                {t('modules.GoogleDeviceImport.title', { ns: 'common' })}
            </CardHeader>
            <Collapse isOpen={open}>
                <CardBody>
                    <CheckboxListItem
                    text={t('googleDeviceImportConfiguration.connectRecentUser', { ns: 'configuration' })}
                    id="connectRecentUser"
                    name="connectRecentUser"
                    value={props.configuration.connectRecentUser}
                    disabled={props.disabled}
                    onChange={(e) => props.updatePart({ connectRecentUser: e.target.checked })}
                    />
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default GoogleDeviceImportConfiguration;